module.exports = __webpack_public_path__ + "img/home_gs_s_icon.436d703.png";